import React from 'react';

import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import classnames from 'classnames';
import {
  BranchCollectionModel, EmailItemModel
} from 'forms/shared/types';
import BranchCollection from 'components/Form/BranchCollection';
import EmailCollectionItem from './EmailCollectionItem';

/*
 This component was designed to be functionally similar to AdditionalActivity,
 See that component if this one appears broke to determine what action to take.
*/

type EmailCollectionType = BranchCollectionModel<EmailItemModel>;

interface Props extends ValidationElementProps, Partial<EmailCollectionType> {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
  emailBranchQuestionLabel?:string
  emailFieldTitle?: string
  appendFieldTitle?: string
  branchFieldTitle?: string
  includeEmailType?: boolean
  hideInitialBranchQuestion?: boolean
  showEmailUnknown?: boolean
}

// TODO: All text values in this file should be moved to and retrieved from an i18n file.
export default class EmailCollection extends ValidationElement<Props> {
  // updateBranch always ensures  the list is complete collection with a minimum of one item.
  updateBranch = (values: Partial<EmailCollectionType>) => {
    const queue = values;
    // Ensue the final response is the No response always
    const finalEmail:EmailItemModel = { Email: { value: '', name: 'email', emailUnknown: false }, Has: { value: 'No' } };

    // if first email is marked unknown, clear other emails
    if (queue.items
      && queue.items.length > 0
      && queue.items[0].Item.Email // TODO: apparently there is some point during render where Email can be undefined...
      && queue.items[0].Item.Email.emailUnknown !== undefined
      && queue.items[0].Item.Email.emailUnknown === true
    ) {
      queue.items = [queue.items?.[0]];
    }

    let items = [...(queue.items || []).filter((x) => x.Item?.Has?.value !== 'No')];
    for (const email of items) {
      if (!email.Item) {
        email.Item = { Email: { value: '', name: 'email' }, Has: { value: 'Yes' } };
      }
      if (!email.Item.Has) {
        email.Item.Has = { value: 'Yes' };
      }
      if (email.Item.Has.value !== 'Yes') {
        email.Item.Has.value = 'Yes';
      }
    }
    items = [...items, { Item: finalEmail }];

    queue.items = items;
    this.props.onUpdate({
      ...queue,
    });
  };

  removeThisEmail = (index: number) => {
    if ((this.props.items?.length || 0) > 1) {
      const items = this.props.items?.filter((value, idx) => idx !== index) || [];
      this.updateBranch({ branch: this.props.branch, items });
    }
  };

  showAnotherEmail = () => {
    const newEmail:EmailItemModel = { Email: { value: '', name: 'email', emailUnknown: false }, Has: { value: 'Yes' } };
    const items = [...(this.props.items || []), { Item: newEmail }];
    this.updateBranch({ branch: this.props.branch, items });
  };

  render() {
    const showRemove = (this.props?.items || []).length > 2;
    return (
      <div className={classnames('email-list', this.props.className)}>

        <BranchCollection
          label={this.props.branchFieldTitle}
          labelSize="h4"
          appendLabel={this.props.appendFieldTitle}
          appendSize="h4"
          {...(this.props || {})}
          onUpdate={this.updateBranch}
          onError={this.props.onError}
          scrollIntoView={this.props.scrollIntoView}
          useYesLabel={this.props.showEmailUnknown}
          {...(this.props.showEmailUnknown ? { yesLabel: 'Add' } : {})}
          useNoLabel={this.props.showEmailUnknown}
          {...(this.props.showEmailUnknown ? { noLabel: "I Don't Know" } : {})}
          hideInitialBranchQuestionAssumeYes={this.props.hideInitialBranchQuestion} // TODO: this is temporary until all uses of this component can appropriately transition from using the initial branch question IDK to another solution
          hideAppend={this.props.hideAppend}// prevents append from showing up it is handled in the child function
          hasSecondaryAppendLabels={this.props.hasSecondaryAppendLabels}
          secondaryNoAppendLabel={this.props.secondaryNoAppendLabel}
          secondaryYesAppendLabel={this.props.secondaryYesAppendLabel}
        >
          <EmailCollectionItem
            attribute={this.props.attribute}
            emailFieldTitle={this.props.emailFieldTitle}
            name="Item"
            bind
            required={this.props.required}
            includeEmailType={this.props.includeEmailType}
            showEmailUnknown={this.props.showEmailUnknown}
            showAccordianActions={this.props.showAccordianActions}
            showRemoveItem={showRemove}
            showAnotherEmail={this.showAnotherEmail}
            removeThisEmail={this.removeThisEmail}
            preventRepeatQuestions
          />
        </BranchCollection>
      </div>
    );
  }
}

EmailCollection.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
  emailFieldTitle: 'What is the email?',
  appendFieldTitle: 'Do you have another email to add?',
  branchFieldTitle: 'Do you have an email to add?',
  includeEmailType: true,
  hideInitialBranchQuestion: true,
  hideAppend: true,
  showEmailUnknown: false,
  hasSecondaryAppendLabels: false,
  secondaryNoAppendLabel: 'No',
  secondaryYesAppendLabel: 'Yes',
  showAccordianActions: true,
  showAnotherEmail: () => {},
  removeThisEmail: () => {},
};
